import {Component, OnInit, OnDestroy, ViewChild, isDevMode} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {FollowUpQuestionComponent} from "../follow-up-question.component";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatDialog} from "@angular/material/dialog";
import {CentreService} from "../../../../../services/centre.service";
import {Observable, Subject} from "rxjs";
import {Centre} from 'src/app/interfaces/Centres';
import {MatTableDataSource} from "@angular/material/table";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ViewFollowUpAssessmentComponent} from "../view-follow-up-assessment/view-follow-up-assessment.component";
import {EmployeeService} from "../../../../../services/employee.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {LogService} from "../../../../../services/log.service";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {Timestamp} from "firebase/firestore";
import {needConfirmation} from "../../../../../confirm-dialog/confirm-dialog.decorator";
import { Subscription } from 'rxjs';
import {map, takeUntil} from "rxjs/operators";
import {FinancialYearService} from "../../../../../services/financial-year.service";

@Component({
  selector: 'app-follow-up-table',
  templateUrl: './follow-up-table.component.html',
  styleUrls: ['./follow-up-table.component.scss']
})
export class FollowUpTableComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  counsellors$: Observable<any[]>
  submittedBy: string | undefined | null = null
  mData: any[] = []
  dataSource: any
  startDate: Date | undefined
  endDate: Date | undefined
  displayedColumns: string[] = ['sr.no','children', 'centre', 'sessionType','dateOfAssessment','submittedBy', 'action'];
  centres$: Observable<Centre[]>
  selectedCentre: Centre | undefined
  // Multi-centre selection with Select All support
  selectedCentres: Centre[] = []
  isLoading = false;  // New loading flag
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
   userData = JSON.parse(localStorage.getItem('userData')!)
  username = this.userData.userName
  baseData: any[] = [];
  private querySub!: Subscription;
  private _destroyed$ = new Subject<void>();
  constructor(private mFirestore: AngularFirestore,
              private readonly mSnackbar: MatSnackBar,
              private readonly mCentreService: CentreService,
              private readonly mEmployeeService: EmployeeService,
              private mLogService: LogService,
              private readonly financialYearService: FinancialYearService,
              private matDialog: MatDialog) {
    this.centres$ = this.mCentreService.getAllCentres().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    )
    this.counsellors$ = this.mEmployeeService.getCounsellers()
this.dataSource = new MatTableDataSource()

  }



  ngOnInit(): void {
    // Pre-fill the date range with the current financial year (search still requires an explicit click)
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;

    this.mFirestore.collection(this.env.counsellingFollowUp, ref => ref.orderBy('dateOfAssessment', 'desc')).valueChanges({idField: 'id'}).pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mData = res
      this.dataSource = new MatTableDataSource(this.mData)
      this.dataSource.sort =this.sort
      this.dataSource.paginator =this.paginator
    })
  }

  // search() {
  //   if (this.selectedCentre) {
  //     this.isLoading = true;  // New loading flag
  //     this.mFirestore.collection(this.env.counsellingFollowUp, ref => ref.where('centreCode', '==', this.selectedCentre!.centreCode)).valueChanges({idField: 'id'}).subscribe(res => {
  //       let d = res
  //       if (this.startDate != undefined && this.endDate != undefined) {
  //
  //         // @ts-ignore
  //         d = res.filter((x) => x.dateOfAssessment!!.toDate()!! >= this.startDate!! && x.dateOfAssessment!!.toDate()!! <= this.endDate!!)
  //       }
  //       this.mData = d
  //       this.dataSource = new MatTableDataSource(this.mData)
  //       this.dataSource.sort =this.sort
  //       this.dataSource.paginator =this.paginator
  //       this.isLoading = false;  // New loading flag
  //     })
  //
  //   }
  //
  //   else {
  //     this.mSnackbar.open('Select a centre first', "", {
  //       duration: 4000,
  //       panelClass: 'error'
  //     })
  //     this.isLoading = false;  // New loading flag
  //   }
  // }

  onCentresSelected(selected: any) {
    this.selectedCentres = Array.isArray(selected) ? selected : (selected ? [selected] : []);
    this.selectedCentre = this.selectedCentres.length ? this.selectedCentres[0] : undefined;
  }

  search() {
    const centreCodes = this.selectedCentres.map(c => c.centreCode).filter(Boolean);
    if (centreCodes.length === 0) {
      this.mSnackbar.open('Select a centre first', "", { duration: 4000, panelClass: 'error' });
      return;
    }

    this.isLoading = true;

    // Clean up previous subscription
    if (this.querySub) {
      this.querySub.unsubscribe();
    }

    // Firestore "in" supports up to 10 values; for larger selections fetch all and filter client-side
    const useInQuery = centreCodes.length <= 10;
    const centreSet = new Set(centreCodes);

    this.querySub = this.mFirestore.collection(this.env.counsellingFollowUp, ref =>
      useInQuery
        ? ref.where('centreCode', 'in', centreCodes)
        : ref.orderBy('dateOfAssessment', 'desc')
    ).valueChanges({idField: 'id'}).pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.baseData = useInQuery ? res : res.filter((x: any) => centreSet.has(x.centreCode));
      // This applies the Date Range and the current "Submitted By" selection
      this.applyAllFilters();
      this.isLoading = false;
    });
  }

  clearAll(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.selectedCentre = undefined;
    this.selectedCentres = [];
    this.submittedBy = null;
    this.baseData = [];
    this.dataSource.data = [];
  }

  applyAllFilters() {
    // If no search has been performed yet, keep table empty
    if (!this.baseData || this.baseData.length === 0) {
      this.dataSource.data = [];
      return;
    }

    let filteredData = [...this.baseData];

    // Filter by Date Range (Mandatory for the data to show properly)
    if (this.startDate && this.endDate) {
      const endOfDay = new Date(this.endDate);
      endOfDay.setHours(23, 59, 59, 999);

      filteredData = filteredData.filter((x: any) => {
        const assessmentDate = x.dateOfAssessment?.toDate();
        return assessmentDate && assessmentDate >= this.startDate! && assessmentDate <= endOfDay;
      });
    }

    // Filter by Submitted By (Dropdown)
    if (this.submittedBy && this.submittedBy !== null) {
      filteredData = filteredData.filter((x: any) => x.submittedBy === this.submittedBy);
    }

    // Final Sort and View Update
    filteredData.sort((a: any, b: any) => b.dateOfAssessment.toDate() - a.dateOfAssessment.toDate());
    this.dataSource.data = filteredData;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  downloadExcel() {
    const tableData = this.dataSource?.filteredData?.length
      ? this.dataSource.filteredData
      : this.dataSource?.data;

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Child Name</th>
        <th>Centre</th>
        <th>Assessment No</th>
        <th>Assessment Date</th>
        <th>Submitted By</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
      <tr>
        <td>${index + 1}</td>
        <td>${x.childName ?? '-'}</td>
        <td>${x.centreName ?? '-'}</td>
        <td>${x.sessionType ?? '-'}</td>
        <td>${
        x.dateOfAssessment && x.dateOfAssessment.toDate
          ? new Date(x.dateOfAssessment.toDate()).toLocaleDateString('en-GB')
          : '-'
      }</td>
        <td>${x.submittedBy ?? '-'}</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['\ufeff' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Counselling_Follow_Up_Assessment_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }


  @needConfirmation()
  deleteChild(element: any) {
    this.mFirestore.collection(this.env.counsellingFollowUp).doc(element.id).delete().then(r => {
      console.log("Deleted successfully")
    })
    let activity = {
      date: new Date().getTime(),
      section: 'Assessment Counseling',
      action: 'Delete',

      description: `Delete Counselling Followup Assessment data by  `,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }

  viewEdit(element: any) {
    this.matDialog.open(FollowUpQuestionComponent, {
        data: element,
        autoFocus: false,
        width: '800%',
        height: '90%'
      }

    )
    let activity = {
      date: new Date().getTime(),
      section: 'Assessment Counseling',
      action: 'Edit',

      description: `Edit Counselling Followup Assessment data by  `,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }


  OpenDialog() {
    this.matDialog.open(FollowUpQuestionComponent, {
      autoFocus: false,
      width: '800%',
      height: '90%'
    })
  }

  //
  // search() {
  //     this.mFirestore.collection(this.env.counsellingFollowUp).valueChanges({idField:'id'}).subscribe(res => {
  //         this.dataSource = res
  //     })
  // }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  viewDialog(element: any) {
    this.matDialog.open(ViewFollowUpAssessmentComponent, {
      autoFocus: false,
      width: '800%',
      height: '90%',
      data: element
    })
    let activity = {
      date: new Date().getTime(),
      section: 'Assessment Counseling',
      action: 'View',

      description: `View Counselling Followup Assessment data by  `,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }

  // applyfilters() {
  //   this.dataSource.data = this.mData
  //   if (this.dataSource.data.length >= 1) {
  //     if (this.submittedBy != null) {
  //       // alert('filttering')
  //       this.dataSource.data = this.mData.filter((x: any) => x.submittedBy == this.submittedBy)
  //     }
  //   }
  // }

  applyfilters() {
    // Only filter if we already have data from a search
    if (this.baseData.length > 0) {
      // this.applyAllFilters();
    } else {
      this.mSnackbar.open('Please click Search first to load data', "", { duration: 3000 });
    }
  }

  editAccess(element: any): boolean {
    const ONE_DAY_IN_MILLISECONDS = 86400000;
    const TWO_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 2;
    const THREE_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 3;
    const FOUR_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 4;

    const userData = JSON.parse(localStorage.getItem('userData')!);
    const username = userData?.userName;

    if (username === 'Krisha Shah') {
      return true;
    }

    try {
      const currentTimestamp = Timestamp.now();
      // Safe check for date, fallback to dateOfAssessment
      const sessionTimestamp = element.date ? element.date.toDate().getTime() : (element.dateOfAssessment ? element.dateOfAssessment.toDate().getTime() : 0);
      const timeDifference = currentTimestamp.toMillis() - sessionTimestamp;

      return (username === element.submittedBy && timeDifference <= TWO_DAYS_IN_MILLISECONDS);
    } catch (e) {
      return false;
    }
  }
    protected readonly PermissionType = PermissionType;

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
